export default["__VITE_ASSET__VNpq2s2S__","__VITE_ASSET__IMQHi7d8__"];